import { Box, Typography } from '@mui/material';
import { SendDrawerContext } from 'components/@home/@documents/SentDocuments/SendDrawerContext';
import ConfigSubStep from 'components/@home/@documents/SentDocuments/steps/StepFiles/ConfigSubStep';
import { func, object } from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import authUser from 'store/selectors/authUser';
import { I18n } from 'utils/i18n';

const toConfigType = type => {
  if (type === 'xml') return 'xml';
  if (type === 'single-pdf') return 'single-pdf';
  return 'multi-pdf';
};

/**
 * XML-only data mapping step (PDF mapping lives in {@link StepSetupDocument}).
 */
const StepDataMapping = ({ template, setTemplate }) => {
  const user = useSelector(authUser);

  const formatForConfig = useMemo(
    () => ({
      ...template,
      type: toConfigType(template.type),
      items: Array.isArray(template.items) ? template.items : [],
    }),
    [template],
  );

  const currentFile = useMemo(
    () => ({
      xml: template.xmlContent || template.xml || '',
      filename: `${template.name || 'template'}.xml`,
      pageNum: 1,
    }),
    [template.name, template.xml, template.xmlContent],
  );

  const sendDrawerValue = useMemo(
    () => ({
      file: formatForConfig,
      setFile: next => setTemplate(t => ({ ...t, items: next?.items || t.items })),
    }),
    [formatForConfig, setTemplate],
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, minHeight: 400 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {I18n.t('HrBot.EditTemplate.Wizard.dataMappingTitle')}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {I18n.t('HrBot.EditTemplate.Wizard.dataMappingHelp')}
      </Typography>
      <SendDrawerContext.Provider value={sendDrawerValue}>
        <ConfigSubStep
          user={user}
          hasDivisions={false}
          currentFile={currentFile}
          close={() => null}
          onSaveItems={nextItems => setTemplate(t => ({ ...t, items: nextItems }))}
          onItemsChange={nextItems => setTemplate(t => ({ ...t, items: nextItems }))}
        />
      </SendDrawerContext.Provider>
    </Box>
  );
};

StepDataMapping.propTypes = {
  template: object.isRequired,
  setTemplate: func.isRequired,
};

export default StepDataMapping;
